import React, { useEffect, useState, useRef } from 'react';
import { unsubAction } from "../../ApiCalls/Home/api_v1_home";
import styles from '../../styles/home/home.module.css';
import Loader from '../Animations/Loader';
import LoaderBrown from '../Animations/LoaderBrown';
import MsisdnForm from '../MsisdnForm/MsisdnForm';
import CurrentDetailsTable from '../CurrentDetailsTable/CurrentDetailsTable';
import HistoryDetails from '../HistoryDetailsTable/HistoryDetails';
export default function Home({ showSplash }) {
    // let navigate = useNavigate();
    const getVideosOnceLoad = useRef(false);
    const msisdnRef = useRef(null);
    const btnSubmitRef = useRef(null);
    const [isDisabled, setIsDisabled] = useState(false);
    const [showError, setShowError] = useState(false);
    const [erroMsg, setErrorMsg] = useState("We can not process your request at this time please try later");
    const [detailsLoading, setDetailsLoading] = useState(null);
    const [details, setDetails] = useState([
        {
            msisdn: "",
            status: "",
            action: "",
            history: ""
        }
    ]);


    const setAllDetails = (newDetails) => {
        setDetails(newDetails);
    };


    const updateSingleDetail = (updatedItems) => {

        setDetails((prevDetails) =>
            prevDetails.map((item) => {
                const match = updatedItems.find(updated => updated.service === item.service);
                return match ? { ...item, ...match } : item;
            })
        );
    };


    useEffect(() => {
        document.title = "Admin Home | CC";
        document.body.addEventListener("keydown", onKeyDown);
        return () => {
            document.body.removeEventListener("keydown", onKeyDown);
        };
    }, [])

    function onKeyDown(e) {
        document.querySelector('input[name="phone"]').focus();
        if (e.which === 123) {
            e.preventDefault();
        }
        if (e.ctrlKey && e.shiftKey && e.which === 73) {
            e.preventDefault();
        }
        if (e.ctrlKey && e.shiftKey && e.which === 75) {
            e.preventDefault();
        }
        if (e.ctrlKey && e.shiftKey && e.which === 67) {
            e.preventDefault();
        }
        if (e.ctrlKey && e.shiftKey && e.which === 74) {
            e.preventDefault();
        }
    }

    return (
        <main onContextMenu={(e) => e.preventDefault()} id={styles.drawer} className={styles.Content} >
            {getVideosOnceLoad.current && <Loader />}
            <div className='text-center'>
                <h1 className='text-black'>Enter Msisdn</h1>
                {showError && (<p>{erroMsg}</p>)}
                <MsisdnForm msisdnRef={msisdnRef} updateDetails={setAllDetails} setDetailsLoading={setDetailsLoading} setShowError={setShowError} setIsDisabled={setIsDisabled} setErrorMsg={setErrorMsg} />

                {detailsLoading === true
                    ?
                    <div className='position-relative'>
                        <LoaderBrown></LoaderBrown>
                    </div>
                    :
                    detailsLoading === false ?
                        <>
                            <CurrentDetailsTable msisdnRef={msisdnRef} details={details} updateDetails={updateSingleDetail} setDetailsLoading={setDetailsLoading} setShowError={setShowError} setIsDisabled={setIsDisabled} setErrorMsg={setErrorMsg} />

                        </>
                        :
                        null
                }

            </div>
        </main>
    );
}